import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import HomepageNewsGallery from 'src/component/HomepageNewsGallery';
import CourseCard from 'src/component/CourseCard';

const featuredCourses: Array<string> = ['coding_interview', 'coming_soon'];

export default function Homepage() {
  const featuredCourseCards = featuredCourses.map((courseId) => (
    <CourseCard courseId={courseId} key={courseId} />
  ));
  return (
    <Box
      sx={{
        mt: 5,
      }}
    >
      <Container>
        <Grid container>
          <HomepageNewsGallery />
        </Grid>
        <Grid container spacing={3} sx={{ alignItems: 'stretch' }}>
          {featuredCourseCards}
        </Grid>
      </Container>
    </Box>
  );
}
